import React, { FC } from 'react';
import { getTodayDay } from 'utils/date';
import { WeekDay } from 'data/types/global';

import { Props } from './types';
import {
  Card,
  Row,
  Header,
  Content,
  RightSection,
  Avatar,
  BrandName,
  ArrowDown,
  ArrowUp,
  Hour,
  IntegrationStatus,
  StatusLabel,
  FloatRight,
  ColoredDot,
} from './styles';
import useConnect from './connect';

const BrandStatus: FC<Props> = ({ brand }) => {
  const { hide, setHide, isBrandOnline } = useConnect(brand);
  const { open, timings } = brand.timings[getTodayDay() as WeekDay];

  return (
    <Card>
      <Header onClick={() => setHide(!hide)}>
        <Avatar src={brand.image.src} alt={brand.image.alt} />
        <RightSection>
          <BrandName>{brand.name}</BrandName>
          <FloatRight>
            <StatusLabel online={isBrandOnline}>
              <ColoredDot online={isBrandOnline} />
            </StatusLabel>
            {hide ? <ArrowDown /> : <ArrowUp />}
          </FloatRight>
        </RightSection>
      </Header>

      <Content hidden={hide}>
        <Row>
          <Avatar as="span" />
          <RightSection>
            {open ? (
              timings.map(({ timeStart, timeEnd }, index) => (
                <Hour key={`${brand.id}-${index.toString()}`}>
                  {`${timeStart.hours}:${timeStart.minutes} ${timeStart.timeZone}`}{' '}
                  - {`${timeEnd.hours}:${timeEnd.minutes} ${timeEnd.timeZone}`}
                </Hour>
              ))
            ) : (
              <Hour>Closed</Hour>
            )}
          </RightSection>
        </Row>

        {brand.integrations.map((integration) => (
          <IntegrationStatus
            key={`${brand.id}-${integration.id}`}
            integration={integration}
            brandId={brand.id}
          />
        ))}
      </Content>
    </Card>
  );
};

export default BrandStatus;

// TODO: TFR-44 move to status group
